import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { UserStore } from './UserStore';
import { CommonStore } from './CommonStore';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        user: UserStore.ExtractVuexModule(UserStore),
        common: CommonStore.ExtractVuexModule(CommonStore),
    },
    plugins: [
        createPersistedState({
            key: 'buttery-surveillance',
            paths: ['user'],
            storage: window.sessionStorage,
        }),
    ],
});

export const vxm = {
    user: UserStore.CreateProxy(store, UserStore),
    common: CommonStore.CreateProxy(store, CommonStore),
};
